import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import Grid from "@material-ui/core/Grid";
import styles from "./CustomerContract.module.scss";

class AgentContractHeader extends Component {
  render() {
    return (
      <Grid container className={styles.headerRow}>
        <Grid className={styles.gridHeader} item xs={4}>
          <span>{this.props.t("AgentContract.agent")}</span>
        </Grid>
        <Grid className={styles.gridHeaderCentered} item xs={4}>
          <span>{this.props.t("CustomerContract.dateUploaded")}</span>
        </Grid>
        <Grid className={styles.gridHeaderRight} item xs={4}>
          <span>{this.props.t("CustomerContract.document")}</span>
        </Grid>
      </Grid>
    );
  }
}

export default withTranslation("emp")(AgentContractHeader);
